<p-card header="Piece Rate Configuration">
  <div *ngIf="showAdjustmentOption">
    <h4 class="centered">Week Ending {{saturdayDate | dateTimeToFormat: 'MM/dd/yyyy'}}</h4>
    <h4>Adjustment Calculation</h4>
    <div class="p-grid" style="margin-top: 1em;">
      <div class="p-col-12">
        <p-radioButton
          name="group1"
          value="combinedShift"
          label="Combined Shifts"
          [formControl]="combShiftControl"
          inputId="combinedShift"
        ></p-radioButton>
      </div>
      <div class="p-col-12">
        <p-radioButton
          name="group1"
          value="separateShift"
          label="Separate Shifts"
          [formControl]="combShiftControl"
          inputId="separateShift"
        ></p-radioButton>
      </div>
    </div>
  </div>
  <div *ngIf="showNonProductiveHours">
    <h4>Default Non Productive Time (Hours)</h4>
    <div class="p-grid" style="margin-top: 1em;">
      <div class="p-col-12">
        <time-entry [formControl]="defaultNPT" (change)="onChangeDefaultNpt()" [showButton]="false"></time-entry>
      </div>
    </div>
  </div>
</p-card>

<p-dialog header="Piece Rate Adjustment Calculation" [visible]="combShiftConfirmVisible" [modal]="true" appendTo="body">
  <p>Are you sure you want to {{ combShiftControl.value === 'combinedShift' ? 'Combine' : 'Separate' }} shifts for this week's Piece Rate Calculations?</p>
  <p-footer>
    <button pButton class="p-button-info" label="Cancel" [disabled]="changingAdjCalculation" (click)="cancelAdjustmentCalculation()"></button>
    <button pButton label="Change" [disabled]="changingAdjCalculation" (click)="confirmAdjustmentCalculation()"></button>
  </p-footer>
</p-dialog>
